import { Component } from '@angular/core';

@Component({
  selector: 'i-speaker',
  imports: [],
  templateUrl: './i-speaker.html',
  host: {
    class: 'grid place-items-center',
  },
})
export class ISpeaker {}
